import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

export default function BooleanFlag({ falseIsGood = false, value }: { falseIsGood?: boolean; value: boolean }) {
  const good = falseIsGood ? !value : value;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Box
        component="span"
        sx={{
          bgcolor: good ? 'success.main' : 'warning.main',
          borderRadius: '50%',
          flexShrink: 0,
          height: 8,
          width: 8,
        }}
      />
      <Typography variant="body2">{value ? 'Yes' : 'No'}</Typography>
    </Stack>
  );
}
